import * as Factory from 'factory.ts'
import faker from 'faker'

import { type Address } from '@webapp/models/Address'
import { AddressStringTypes } from '@webapp/models/enums'

export const AddressMock = Factory.Sync.makeFactory<Address>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.words(3)),
  addressLineOne: Factory.each(() => faker.address.streetAddress()),
  addressLineTwo: Factory.each(() => faker.address.streetAddress()),
  city: Factory.each(() => faker.address.city()),
  postalCode: Factory.each(() => faker.address.zipCode()),
  state_province: Factory.each(() => faker.address.state()),
  country: Factory.each(() => faker.address.country()),
  active: true,
  addressAssociation: AddressStringTypes.GENERAL,
  branch: Factory.each(() => faker.random.number()),
  is_active: true,
  created_at: Factory.each(() => faker.date.past().toISOString()),
  last_changed_by: null,
  is_home: false,
  updated_at: Factory.each(() => faker.date.past().toISOString()),
})
